import classNames from "classnames";
import React from "react";
import * as styles from "./styles.module.scss";
const InfoText = ({ className }) => {
    return (React.createElement("div", { className: classNames(className, styles.info) },
        React.createElement("p", null, "Dependencies describe how the rate of cell dynamics are impacted by the culture environment. Dynamic rates are described as a maximal possible rate."),
        React.createElement("p", null, "Dependencies describe which values of an environmental variable allow for that maximum rate and how deviations from these values modulate the rate down."),
        React.createElement("p", null, "The final effective rate of a dynamic at any point in time is calculated based on all its dependencies.")));
};
export default InfoText;
